// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"8b2f035b","235":"c9044613","307":"cea2aee7","383":"5fd5e84c","427":"79b70166","453":"e1ea8cda","489":"1c28876f","572":"a2915815","669":"d5915185","706":"9a3ed74a","723":"c0838348","929":"9c9d4451"}[chunkId] + ".chunk.js";
};